import { useState } from "react";
import { Link } from "react-router-dom";
import PublicNav from "@/components/PublicNav";
import api from "@/lib/api";
import { toast } from "sonner";
import { Mail, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch {
      toast.error("Something went wrong — please try again");
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-[#070707] text-white" data-testid="forgot-password-page">
      <PublicNav />
      <div className="max-w-md mx-auto px-6 py-12">
        <div className="font-mono-jp text-xs text-[#d7ff00] tracking-[0.3em] uppercase">PASSWORD RECOVERY</div>
        <h1 className="mt-3 font-display text-5xl uppercase">Forgot <span className="text-[#d7ff00]">password</span>?</h1>

        {sent ? (
          <div className="mt-8 bg-[#0a0a0a] border border-[#d7ff00] p-6" data-testid="forgot-sent">
            <CheckCircle2 className="w-10 h-10 text-[#d7ff00]" />
            <h2 className="mt-3 font-display text-2xl uppercase">Check your inbox</h2>
            <p className="mt-2 text-[#bbb] text-sm">If an account exists for <span className="text-white">{email}</span>, we just sent a reset link. It expires in 1 hour.</p>
            <p className="mt-3 text-[#888] text-xs">Didn't get it? Check your spam folder, or try again in a few minutes.</p>
            <Link to="/login" className="mt-5 inline-block bg-[#d7ff00] text-black font-display tracking-wider uppercase px-6 py-3 hover:bg-white" data-testid="back-to-login">
              Back to login
            </Link>
          </div>
        ) : (
          <>
            <p className="mt-4 text-[#bbb] text-sm">Enter the email you registered with — we'll send you a secure link to reset your password.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="font-mono-jp text-[10px] uppercase tracking-widest text-[#888] flex items-center gap-1"><Mail className="w-3 h-3" /> Email</label>
                <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
                  className="mt-2 w-full bg-[#0e0e0e] border border-[#222] focus:border-[#d7ff00] outline-none px-4 py-3" data-testid="forgot-email" />
              </div>
              <button type="submit" disabled={busy || !email} className="w-full bg-[#d7ff00] text-black font-display tracking-wider uppercase text-xl py-4 hover:bg-white disabled:opacity-50" data-testid="forgot-submit">
                {busy ? "Sending…" : "Send reset link"}
              </button>
            </form>
            <p className="mt-6 text-sm text-[#888]">Remembered it? <Link to="/login" className="text-[#d7ff00]" data-testid="goto-login">Sign in</Link></p>
          </>
        )}
      </div>
    </div>
  );
}
